<template>
    <div class="flex-wrap hover-lighter" style="background:linear-gradient(to bottom right,var(--bg2),var(--border));border:1px solid var(--border);border-radius:3px;height:25px;font-size:12px;padding:0 5px;margin:0 10px;" @click="DownloadWithName('https://nbgzfiles-1257839135.cos.ap-shanghai.myqcloud.com/files/'+fileObj.url,fileObj.name)">
        <img  v-if="fileObj.ext" :src="`https://nbgzfiles-1257839135.cos.ap-shanghai.myqcloud.com/assets/filetype/${fileObj.ext}.png`" style="margin-right:5px;width:20px;height:20px;" />

      <BaseIcon icon="document" v-else style="margin-right:5px;"  />
      <div style="flex-grow:1;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;" :title="error || fileObj.name">
      <template v-if="loading">
        加载中
      </template>
      <template v-else-if="error">
        {{ error }}
      </template>
      <template v-else>
        {{ fileObj.name }}<span v-if="fileObj.size">({{fileObj.size}})</span>

      </template>
      </div>
    </div>
  </template>

<script>
export default {
  data() {
    return {
      fileObj: {},
      loading: false,
      error: '',
    };
  },
  props: {
    'url': {
      type: String,
    },
    'value': {
      type: String,
    },
    'file': {
      type: Object,
    },
  },
  mounted() {
    this.getFile();
  },
  methods: {
    getFile() {
      if (this.file && this.file.file_id) {
        this.loading = true;
        this.$api.get(`files/${this.file.file_id}`).then((res)=>{
          this.fileObj = res.data.data;
          this.fileObj.name = this.file.name;
        }).catch((e)=>{
          this.error = '文件不存在';
        }).finally(()=>{
          this.loading = false;
        });
      } else if (this.value) {
        this.loading = true;
        this.$api.get(`files/${this.value}`).then((res)=>{
          this.fileObj = res.data.data;
        }).catch((e)=>{
          this.error = '文件不存在';
        }).finally(()=>{
          this.loading = false;
        });
      } else if (this.url) {
        this.file = this.$util.parseFileURL(this.url);
      }
    },
  },
};
</script>

